export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-problem-1.27ade0c1.png";